export default __webpack_public_path__ + "static/media/vid23d_transparent.ba0dc082.png";